<template>
  <v-card class="filterWidgets">
    <div style="overflow: hidden;">
      <v-card-title style="float: left;"><strong>FILTERS</strong></v-card-title>
      <v-card-actions style="float: right;">
        <v-btn @click="applyFilters" color="success">Apply</v-btn>
        <v-btn @click="resetFilters">Reset</v-btn>
      </v-card-actions>
    </div>
    <v-card-text style="max-height: 566px; overflow: auto;">
      <p><small>Once you have finalized your selection/s for a particular filter, please click ‘Apply’ before proceeding to the next so the widget can refresh your options.</small></p>
      <div class="filter-control" v-show="Array.isArray(filters.regions) && filters.regions.length > 0">
        <label>Regions</label>
        <v-select
          :items="filters.regions"
          v-model="selected.regions"
          autocomplete
          multiple
          chips
          item-text="name"
          item-value="id"
          class="dropdown"
        ></v-select>
      </div>
      <div class="filter-control" v-show="$store.state.Dashboard.theme !== 'fulfillment' && (Array.isArray(filters.vendors) && filters.vendors.length > 0)">
        <label>Vendor</label>
        <v-select
          :items="filters.vendors"
          v-model="selected.vendors"
          autocomplete
          multiple
          chips
          item-text="name"
          item-value="id"
          class="dropdown"
        ></v-select>
      </div>
      <div class="filter-control" v-show="Array.isArray(filters.stores) && filters.stores.length > 0">
        <label>Store</label>
        <v-select
          :items="filters.stores"
          v-model="selected.stores"
          autocomplete
          multiple
          chips
          item-text="name"
          item-value="id"
          class="dropdown"
        ></v-select>
      </div>
      <div class="filter-control" v-show="Array.isArray(filters.roles) && filters.roles.length > 0">
        <label>Role</label>
        <v-select
          :items="filters.roles"
          v-model="selected.roles"
          autocomplete
          multiple
          chips
          item-text="name"
          item-value="id"
          class="dropdown"
        ></v-select>
      </div>
      <div class="filter-control" v-show="Array.isArray(filters.reps) && filters.reps.length > 0">
        <label>Originator</label>
        <v-select
          :items="filters.reps"
          v-model="selected.reps"
          autocomplete
          multiple
          chips
          item-text="name"
          item-value="id"
          class="dropdown"
        ></v-select>
      </div>
      <div class="filter-control" v-if="$store.state.Dashboard.theme !== 'fulfillment'" v-show="Array.isArray(filters.departments) && filters.departments.length > 0">
        <label>Department</label>
        <v-select
          :items="filters.departments"
          v-model="selected.departments"
          autocomplete
          multiple
          chips
          item-text="name"
          item-value="id"
          class="dropdown"
        ></v-select>
      </div>
      <div class="filter-control" v-show="Array.isArray(filters.statuses) && filters.statuses.length > 0">
        <label>Status</label>
        <v-select
          :items="filters.statuses"
          v-model="selected.statuses"
          autocomplete
          multiple
          chips
          item-text="name"
          item-value="id"
          class="dropdown"
        ></v-select>
      </div>
      <div class="filter-control" v-if="$store.state.Dashboard.theme === 'conversion' && 1 !== 1">
        <label>Quote Type</label>
        <v-select
          :items="filters.quote_types"
          v-model="selected.quote_types"
          autocomplete
          clearable
          chips
          item-text="name"
          item-value="id"
          class="dropdown"
        ></v-select>
      </div>
      <div class="filter-control" v-show="Array.isArray(filters.service_types) && filters.service_types.length > 0" v-if="$store.state.Dashboard.theme === 'conversion'">
        <label>Service Type</label>
        <v-select
          :items="filters.service_types"
          v-model="selected.service_types"
          autocomplete
          multiple
          chips
          item-text="name"
          item-value="id"
          class="dropdown"
        ></v-select>
      </div>
<!--      <div class="filter-control">-->
<!--        <label>Services/Operation Division</label>-->
<!--        <v-select-->
<!--          :items="filters.divisions"-->
<!--          v-model="selected.divisions"-->
<!--          multiple-->
<!--          chips-->
<!--          item-text="name"-->
<!--          item-value="id"-->
<!--          class="dropdown"-->
<!--        ></v-select>-->
<!--      </div>-->
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import qs from "qs";

export default {
  name: "Filters",
  data() {
    return {
      loading: false,
      abortController: null,
      selected: this.$store.state.Dashboard.widgetConfig.filters,
      currentView: this.$store.state.Dashboard.widgetConfig.viewType,
      currentTheme: this.theme
    }
  },
  methods: {
    fetchData() {
      if (this.abortController)
        this.abortController.abort('The previous request was interrupted.');
      console.log('Fetching filters');

      this.loading = true;
      this.abortController = new AbortController;

      return this.$axios.get(window.location.protocol + process.env.API_ENDPOINT + 'Widget.php', {
        signal: this.abortController.signal,
        params: {
          a: 'filters',
          token: 'dlBWlbFDgR5A0eearsSZBouOH9I9282I',
          params: {
            manufacturer: this.$store.getters.objAuthorize.manufacturer
          },
          constraints: this.selected
        },
        paramsSerializer: params => {
          return qs.stringify(params);
        }
      }).then((response) => {
        this.loading = false;
        this.filters = response.data;
        if (this.selected.length > 0) {
          this.$store.commit('setFilters', this.selected);
        }
      }).catch((err) => {
        this.loading = false;
        console.log('An error occurred: ' + err.toString(), err);
      }).finally(() => {
        this.abortController = null;
        this.$emit('filters-loaded', this.selected);
      });
    },
    applyFilters(event) {
      console.log('Filters Applied', event);
      this.$store.commit('setFilters', this.selected);
      this.$emit('apply-filters', this.selected);
    },
    resetFilters() {
      const selected = Object.keys(this.selected);

      for (let i = 0; i < selected.length; i++) {
        if (this.$store.state.Dashboard.widgetConfig.theme === 'fulfillment') {
          if (selected[i] !== 'vendors') {
            this.selected[selected[i]] = [];
          }
        } else {
          this.selected[selected[i]] = [];
        }
      }

      this.applyFilters();
    }
  },
  props: ['bus', 'theme', 'filters'],
  created() {
    const instance = this;
    // instance.fetchData();

    this.bus.$on('trigger-theme-changed', () => {
      if (this.abortController)
        this.abortController.abort();
    });

    this.bus.$on('trigger-view-update', function (selectedEntity) {

      let viewTypePluralized;

      if (selectedEntity.viewType === 'status') {
        viewTypePluralized = selectedEntity.viewType + 'es';
      } else {
        viewTypePluralized = selectedEntity.viewType + 's';
      }

      if (typeof instance.filters[viewTypePluralized] === "object") {
        const keys = instance.filters[viewTypePluralized].filter(function (val) {
          return selectedEntity.name === val.name
        });

        if (keys.length > 0) {
          instance.selected[viewTypePluralized].push(keys[0].id);
          instance.applyFilters(selectedEntity.name);
        } else {
          console.log(selectedEntity.viewType + ' not found', keys);
        }
      }
    });

    this.bus.$on('theme-changed', function (theme) {
      this.currentTheme = theme;
    });
  }
}
</script>

<style scoped>

</style>
